"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _LoadMoreSkeleton = require("./LoadMoreSkeleton");
Object.keys(_LoadMoreSkeleton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LoadMoreSkeleton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LoadMoreSkeleton[key];
    }
  });
});
